import IncidentListToolbar from '@/views/incident/toolbars/IncidentListToolbar';
import IncidentViewToolbar from '@/views/incident/toolbars/IncidentViewToolbar';
import IncidentView from '@/views/incident/IncidentView';
import IncidentList from '@/views/incident/IncidentList';
import DefaultLayout from '@/layout/DefaultLayout';
import { STATES } from '@/constants';

export const incidentPausedRoutes = [
  {
    path: '/incident-paused',
    name: 'incident-paused',
    components: {
      default: IncidentList,
      toolbar: IncidentListToolbar
    },
    meta: {
      type: STATES.PAUSED,
      sortBy: 'UPDATED_AT',
      title: 'Отложенные',
      layout: DefaultLayout
    }
  },
  {
    path: '/incident-paused/:id',
    name: 'incident-paused-view',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    component: IncidentView,
    meta: {
      layout: DefaultLayout,
      type: STATES.PAUSED
    }
  },
  {
    path: '/incident-paused/:id/more/:moreId?',
    name: 'incident-paused-view-more',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    component: IncidentView,
    meta: {
      layout: DefaultLayout,
      type: STATES.PAUSED
    }
  }
];
